<template>
  <v-expansion-panels focusable>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0`" STATSHEADER>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="text-transform: uppercase;">
                  <v-progress-circular indeterminate v-if="loading" size="20" color="primary"></v-progress-circular>
                  <v-chip label small>{{totals.total}} {{i18n.leads}}</v-chip>   <span v-if="time" style="font-size:11px;">{{time.toFixed(1)}} s</span>
                </span>
              </template>
              <div class="text-center">
                {{totals.total}} {{i18n.leads}}
              </div>
            </v-tooltip>
            <v-tooltip top v-if="tests">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="text-transform: uppercase;">
                  <v-chip 
                    class="px-2 mx-2" 
                    label 
                    outlined
                    small 
                    :color="`${tests.count === tests.success ? 'success' : 'warning'}`"
                  >{{tests.success}} / {{tests.count}} Tests Passed</v-chip>
                </span>
              </template>
              <div class="text-center">
                {{tests.success}} / {{tests.count}} Tests Passed {{tests.last_update}}
              </div>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        <Stats 
          :loading="loading"
          :counter="counter"
          :totals="totals"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
import Stats from '@/components/stats'

export default {
  components: { Stats },
  props:['counter', 'totals', 'loading', 'time', 'sms', 'tests'],
  methods:{
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
  },
  computed:{
    
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },

  }
}
</script>

<style>

</style>